import { Toast } from '@stylehaven/components';
import { sum } from 'lodash-es';

// Not strictly necessary to extend, but doing this for now to be able to show-as-toast
export interface ToastGroup extends Toast {
    childToasts: Toast[];
}

export function ToastGroupGuard(toast: Toast): toast is ToastGroup {
    return toast.hasOwnProperty('childToasts');
}

export function createGroupedToast(toasts: Toast[]): ToastGroup {
    const id: number = sum(toasts.map(toast => toast.id)) + 9990000;
    const messageSuffix: string = toasts.length > 1 ? ` (${toasts.length})` : '';
    return {
        ...toasts[0],
        id,
        childToasts: toasts,
        message: `${toasts[0].message}${messageSuffix}`
    };
}
